import uuid from 'uuid/v1';

export default [
  {
    id: '1',
    NameCo: 'باربری نمونه',
    PhoneCo: '035-33333',
    Name_Manager:'علی رعدآبادی',
    city:"یزد",
    AddressCo: 'یزد سه راه شحنه',
    Phone_Manager: "0555484848",
  },
  {
    id: '2',
    NameCo: 'باربری یزدان',
    PhoneCo: '035-123456',
    Name_Manager:'حسین اسدی',
    city:"تهران",
    AddressCo: 'تهران میدان آزادی',
    Phone_Manager: "09111111",
  },
 
];
